<svelte:options accessors/>
<script lang="ts">
    import {IProductPreview} from "../../interfaces";
    import ProductPreview from "./ProductPreview.svelte";
    import LinearProgress from '@smui/linear-progress';

    export let data: Array<IProductPreview>;
    export let loading: boolean = false;
</script>
<div class="grid-2 gap-1 m:grid-4 m:gap-15">
    {#each data as item}
        <ProductPreview data="{item}"
                        on:add/>
    {:else}
        {#if loading}
            <div class="text-c loading-bar">
                <LinearProgress class="w-100" indeterminate/>
                <small>Cargando...</small>
            </div>
        {:else}
            No hay items disponibles
        {/if}
    {/each}
</div>

<style>
    .loading-bar {
        margin-top: 5rem;
        grid-column-start: 1;
        grid-column-end: 8;
    }
</style>
